import { HomeDisplayBanner } from 'src/admin-entity/interface/home-display/home-display-banner.interface';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';

export interface BannerInitialState {
    bannerList: Page<HomeDisplayBanner>;
    bannerListForModal: Page<HomeDisplayBanner>;
    bannerSearchCondition: {
        title: string;
        status: HomeDisplayBanner['status'];
        linkType: HomeDisplayBanner['linkType'];
        bannerType: HomeDisplayBanner['bannerType'];
        [key: string]: any;
        take: number;
        page: number;
    };

    bannerSearchConditionForModal: {
        title: string;
        status: HomeDisplayBanner['status'];
        linkType: HomeDisplayBanner['linkType'];
        bannerType: HomeDisplayBanner['bannerType'];
        [key: string]: any;
        take: number;
        page: number;
    };
    selectedBanners: HomeDisplayBanner[];
}

export const initialState: BannerInitialState = {
    bannerList: {
        list: [],
        page: {
            count: 0,
            nextPage: null,
        },
    },
    selectedBanners: [],
    bannerListForModal: {
        list: [],
        page: {
            count: 0,
            nextPage: null,
        },
    },
    bannerSearchCondition: {
        title: '',
        status: 'all',
        linkType: 'all',
        page: 0,
        take: 50,
        bannerType: 'all',
    },

    bannerSearchConditionForModal: {
        title: '',
        status: 'all',
        linkType: 'all',
        page: 0,
        take: 50,
        bannerType: 'all',
    },
};
